import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Actions from '../../actions';
import APP_ACTIONS from '../../constants/app-actions';
import PaymentStep from '../../components/checkout-steps/payment-step';
import CheckoutStepCalculator from '../../services/checkout-step-calculator';
import APP_ROUTES from '../../constants/app-routes';

const mapStateToProps = (state, ownProps) => ({
    order: state.order,
    placedOrder: state.placedOrder,
    locale: state.locale,
    hasExtraTimeCheckout: state.cartState.hasExtraTimeCheckout,
    gracePeriod: state.cartState.gracePeriod,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentCheckoutStep: () => {
        dispatch({
            type: APP_ACTIONS.SET_CURRENT_CHECKOUT_STEP,
            payload: 'payment',
        });
    },

    handlePaymentFormSubmit: (formData, order, locale) => dispatch(Actions.goToNextStep(order, locale, formData)),

    handleCheckoutStepNotEditable: (order, placedOrder) => {
        /* Redirect to last step if order is already placed */
        if (placedOrder.id) {
            dispatch(push(APP_ROUTES.checkout[`${placedOrder.checkout_steps.slice(-1)}PageRoute`]));
        } else if (order.id) {
            const previousStep = CheckoutStepCalculator.previous(order.checkout_steps, 'payment');

            dispatch(push(APP_ROUTES.checkout[`${previousStep}PageRoute`]));
        } else {
            dispatch(push(APP_ROUTES.cartPageRoute));
        }
    },

    redirectToCart: () => dispatch(push(APP_ROUTES.cartPageRoute)),

    clearCreditCardData: () => {
        dispatch({
            type: APP_ACTIONS.VALIDATE_CREDIT_CARD,
            payload: false,
        });
    },

    showFormErrors: (errorNode) => {
        // dispatch(Actions.showFlash(errorNode, 'danger'));
    },
});

const PaymentStepConnector = connect(mapStateToProps, mapDispatchToProps)(PaymentStep);

export default PaymentStepConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/checkout-steps/payment-step-connector.js
 **/